module.exports = __webpack_public_path__ + "img/logo-avatar.600a17f1.jpg";